import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function AvisoLegal() {
  const navigate = useNavigate();

  return (
    <div className="bg-[#f5f1ea] min-h-screen text-[#141414]">
      {/* Header */}
      <header className="border-b border-[#141414]/10 bg-[#f5f1ea] sticky top-0 z-40">
        <div className="w-full px-6 md:px-12 lg:px-20 h-[64px] flex items-center justify-between">
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center gap-2 text-[#141414]/60 hover:text-[#141414] text-[13.5px] transition-colors"
          >
            <ArrowLeft size={15} />
            Volver
          </button>
          <a href="/" className="flex items-center gap-2">
            <svg width="20" height="20" viewBox="0 0 26 26" fill="none" className="text-[#141414]">
              <path d="M2 4 L13 22 L24 4 L19 4 L13 14 L7 4 Z" fill="currentColor" />
            </svg>
            <span className="font-serif text-[18px] tracking-tight">Escalado</span>
          </a>
        </div>
      </header>

      {/* Content */}
      <main className="w-full px-6 md:px-12 lg:px-20 py-16 md:py-24">
        <div className="max-w-[780px]">
          <p className="text-[11px] uppercase tracking-[0.22em] text-[#141414]/45 mb-5">Información legal</p>
          <h1 className="font-serif text-[36px] md:text-[48px] leading-[1.06] tracking-[-0.02em] mb-12">Aviso Legal</h1>

          <div className="prose-escalado space-y-10 text-[#141414]/80 text-[15.5px] leading-[1.75]">

            <section className="space-y-4">
              <h2 className="font-serif text-[22px] text-[#141414] leading-tight tracking-[-0.01em]">1. Titular del sitio web</h2>
              <p>
                En cumplimiento de lo establecido en la normativa aplicable sobre servicios de la sociedad de la información, se informa al usuario de los datos identificativos del titular de este sitio web:
              </p>
              <div className="bg-[#ece6db] p-6 space-y-2 text-[14.5px]">
                <p><span className="font-medium text-[#141414]">Razón social:</span> Zeus Digital Business Ltd</p>
                <p><span className="font-medium text-[#141414]">Domicilio social:</span> Covent Garden, 73, Londres, Reino Unido</p>
                <p><span className="font-medium text-[#141414]">Oficina España:</span> C/ de les Barques, 2, 2ª planta, Ciutat Vella, 46002 Valencia, España</p>
                <p><span className="font-medium text-[#141414]">Sitio web:</span> escalado.com</p>
                <p><span className="font-medium text-[#141414]">Email de contacto:</span> info@escalado.com</p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="font-serif text-[22px] text-[#141414] leading-tight tracking-[-0.01em]">2. Objeto y ámbito de aplicación</h2>
              <p>
                El presente Aviso Legal regula el acceso y uso del sitio web <strong>escalado.com</strong> (en adelante, "el Sitio Web"), titularidad de Zeus Digital Business Ltd. El acceso y/o uso de este Sitio Web implica la aceptación plena y sin reservas de todas y cada una de las disposiciones incluidas en este Aviso Legal.
              </p>
              <p>
                Zeus Digital Business Ltd se reserva el derecho de modificar cualquier tipo de información que pudiera aparecer en el Sitio Web, sin obligación de preavisar o comunicar dichas modificaciones a los usuarios.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="font-serif text-[22px] text-[#141414] leading-tight tracking-[-0.01em]">3. Propiedad intelectual e industrial</h2>
              <p>
                Todos los contenidos del Sitio Web —incluyendo, con carácter enunciativo y no limitativo, textos, fotografías, gráficos, imágenes, iconos, tecnología, software, enlaces y demás contenidos audiovisuales o sonoros, así como su diseño gráfico y código fuente— son propiedad intelectual de Zeus Digital Business Ltd o de terceros que han autorizado su uso, sin que pueda entenderse cedido al usuario ningún derecho de explotación sobre los mismos.
              </p>
              <p>
                El nombre comercial <strong>Escalado</strong>, el logotipo y el término <strong>Protocolo Escalado™</strong> son marcas registradas o en proceso de registro. Queda expresamente prohibida su reproducción total o parcial sin autorización escrita del titular.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="font-serif text-[22px] text-[#141414] leading-tight tracking-[-0.01em]">4. Condiciones de uso</h2>
              <p>El usuario se compromete a hacer uso del Sitio Web de conformidad con la ley, este Aviso Legal y las buenas costumbres. Con carácter enunciativo y no exhaustivo, el usuario se abstendrá de:</p>
              <ul className="space-y-2 pl-5 border-l-2 border-[#141414]/15">
                <li>Reproducir, copiar, distribuir o comunicar públicamente los contenidos del Sitio Web sin autorización.</li>
                <li>Utilizar el Sitio Web con fines ilícitos o que lesionen derechos de terceros.</li>
                <li>Introducir o difundir en la red virus informáticos o cualquier otro sistema físico o lógico que sea susceptible de provocar daños.</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="font-serif text-[22px] text-[#141414] leading-tight tracking-[-0.01em]">5. Exclusión de garantías y responsabilidad</h2>
              <p>
                Zeus Digital Business Ltd no garantiza la inexistencia de errores en el acceso al Sitio Web ni en sus contenidos. La empresa no será responsable de los daños que puedan derivarse de interferencias, interrupciones, virus informáticos, averías telefónicas o desconexiones en el funcionamiento operativo del sistema electrónico, de retrasos o bloqueos en el uso del Sitio Web causados por deficiencias o sobrecargas de Internet o en otros sistemas electrónicos.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="font-serif text-[22px] text-[#141414] leading-tight tracking-[-0.01em]">6. Ley aplicable y jurisdicción</h2>
              <p>
                Las presentes condiciones se rigen por la legislación española y del Reino Unido. Para la resolución de cualquier controversia derivada del acceso o uso del Sitio Web, las partes se someten, con renuncia expresa a cualquier otro fuero, a los juzgados y tribunales competentes.
              </p>
            </section>

            <section className="border-t border-[#141414]/10 pt-8">
              <p className="text-[13px] text-[#141414]/45">Última actualización: mayo de 2026</p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}
